import React, { useState, useEffect } from "react";
// import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import backicon from "./../../../../../Assets/icons/backIcon.svg"
// import "./index.scss";
import { useNavigate } from "react-router-dom";
// import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import "react-toastify/dist/ReactToastify.css";
// import axiosInstance from "../../../../../services/api/API";
// import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
// import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
// import Loader from "../../../../../customComponents/CustomLoader";
// import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";
import { showAlert } from "../../../../customComponents/CustomSweetAlert/ShowAlert"
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../services/api/API";
import Loader from "../../../../customComponents/CustomLoader";

const AddGracePeriod = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [ userTypedd, setUserTypedd ] = useState([])
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");

  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("businessPartnerId")


  // const handleSubmit = async () => {
  //   console.log("productformdata", formData);
    
  //   // Validate form before submission
  //   const errors = {};
  //   let isValid = true;
  
  //   CustomerInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       } else if (
  //         field.required &&
  //         field.validation &&
  //         field.validation.pattern &&
  //         !field.validation.pattern.test(formData[field.name])
  //       ) {
  //         errors[field.name] = field.validation.message;
  //         isValid = false;
  //       }
  //     }
  //   });
  
  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }
  //   const confirmation = await showAlert({
  //     title: "Confirmation",
  //     text: "Are you sure you want to create a record in product?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel",
  //   });
  
  //   if (!confirmation.isConfirmed) {
  //     return;
  //   }
  
  //   setLoading(true); 
  
  //   try {

  //     const payload = {
  //       vinNum: formData.vinNum,
  //       warrantyFrom: formData.warrantyFromVal,
  //       warrantyTo: formData.warrantyToVal,
  //       warrantyDays: formData.warrantyDays,
  //     };
  
  //     const response = await axiosInstance.post("/grace-warranty/create", payload, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });
  
  //     console.log("API Response:", response.data);
  
  //     if (response.status === 200) {
  //       await showAlert({
  //         title: "Success",
  //         text: "Product created successfully.",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       });
  //       navigate("/admin/manage-product/product");
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  
  //     const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
  //     await showAlert({
  //       title: "Something went wrong",
  //       text: errorMessage,
  //       confirmButtonText: "OK",
  //     });
  //     setLoading(false);
  //   } finally {
  //     setLoading(false); // Hide loading state
  //   }
  // };
  

  const handleSubmit = async () => {
    console.log("productformdata", formData);
  
    // Validate form before submission
    const errors = {};
    let isValid = true;
  
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    // Warranty days limit check
    if (parseInt(formData.warrantyDays) > 75) {
      await showAlert({
        title: "Invalid Warranty Period",
        text: "The extended grace period should not exceed 75 days.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
  
    const confirmation = await showAlert({
      title: "Confirmation",
      text: "Are you sure you want to extend the warranty period?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });
  
    if (!confirmation.isConfirmed) {
      return;
    }
  
    setLoading(true);
  
    try {
      const payload = {
        vinNum: formData.vinNum,
        warrantyFrom: formData.warrantyFromVal,
        warrantyTo: formData.warrantyToVal,
        warrantyDays: formData.warrantyDays.toString(),
      };
  
      const response = await axiosInstance.post("/grace-warranty/create", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
  
      console.log("API Response:", response.data);
  
      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Grace Period updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/sales/manage-warranty/grace-period-list");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
  
      const errorMessage = error?.response?.data?.data|| "An error occurred while processing your request.";
      console.log(errorMessage, "errorMessage")
      await showAlert({
        // title: "Confirmation",
        icon: "warning",
        text: errorMessage,
        confirmButtonText: "OK",
      });
      setLoading(false);
    } finally {
      setLoading(false); // Hide loading state
    }
  };
  

  const CustomerInputs = [
  
    {
      name: "vinNum",
      label: "Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      placeholder:"Enter Product Name",
      validation: { required: true},
    },
    {
      name: "warrantyFromVal",
      label: "Warranty From",
      placeholder:"Enter Warranty From",
      type: "date",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "warrantyToVal",
      label: "Warranty To",
      placeholder:"Enter Warranty To",
      type: "date",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "warrantyDays",
      label: "Warranty Days",
      placeholder:"Enter Warranty Days",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      disbaled: true
    },
   
  ];

 
  return (
    <>
       <div>
      {loading ? ( 
        <Loader />
      ) : (
      <><div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
              <img src={backicon} alt="back" />
              <span className="backbtntitle">Add Grace Period</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please Enter Grace Details
                </span>
                <DynamicForm
                  formConfig={CustomerInputs}
                  formData={formData}
                  setFormData={setFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors} />
              </div><div className="btncontainer mt-3">
                <button onClick={handleSubmit} className="submit-btn">
                  Submit
                </button>
              </div></>
       )}
  </div>
    
    </>
  );
};

export default AddGracePeriod;
